
// component function
import { connect } from 'react-redux';
import * as ComponentFunctions from './ConsumptionList.Functions';
import { useEffect, useState, useMemo } from 'react';
import { Avatar, Button, createTableColumn, TableCellLayout, TableColumnDefinition, Label, DataGrid, DataGridHeader, DataGridRow, DataGridHeaderCell, DataGridBody, DataGridCell, DataGridProps, TableRowId, Spinner, Checkbox, Badge, Input, InputOnChangeData, SearchBox, Divider as Separator } from '@fluentui/react-components';
import { ProtocolConsumption } from '../../../models/Entities/Protocols/ProtocolConsumption';
import { AlertOn16Regular, ArrowFlowDiagonalUpRight20Filled, ArrowFlowUpRight16Filled, BranchFork16Filled, BranchFork20Filled, BranchFork24Filled, CoinStack16Regular, DeleteRegular, EditRegular, Important16Regular } from '@fluentui/react-icons';
import moment, { max } from 'moment';
import { useTranslation } from 'react-i18next';

import './ConsumptionList.Styles.css';

import { FontSizes } from '@fluentui/react';
import { ProtocolPatient } from '../../../models/Entities/Protocols/ProtocolPatient';
import { ContractConcept } from '../../../models/Entities/Contracts/ContractConcept';

// components
import ConsumptionListMenuComponent from './ConsumptionList.Menu/ConsumptionList.Menu.Component';
import { PaginationControlComponent } from '../../../commons/component/PaginationControl/PaginationControl.Component';
import ConsumptionVisitListComponent from '../ConsumptionVisitList/ConsumptionVisit.List.Component';
import ConsumptionListFilterComponent from './ConsumptionListFilter/Consumption.List.Filter.Component';
import ConsumptionDetailsCompoment from '../ConsumptionDetails/ConsumptionDetails.Component';

// forms
import ConsumptionFormComponent from '../ConsumptionForm/Consumption.Form.Component';

// models
import { ContractStage } from '../../../models/Entities/Contracts/ContractStage';
import { Practitioner } from '../../../models/Entities/Practitioners/Practitioner';
import { IConsumptionStatusProps } from '../../../commons/component/Inputs/ProtocolConsumptionStatusSelector/ProtocolConsumptionStatusSelector.Functions';

import { IConsumptionsFilters } from '../../../models/Filters/ConsumptionsFilters';


const ConsumtionListComponent = (props: ComponentFunctions.Props) => {
    const { t } = useTranslation();

    const [selectedConsumption, setSelectedConsumption] = useState<ProtocolConsumption | null>(null);

    const [currentfilter, setCurrentFilter] = useState<IConsumptionsFilters>({
        SelectedConsumptions: [],
        SelectedProtocolPatients: [],
        SelectedContractConcepts: [],
        SelectedCurrencys: '',
        SelectedContractStages: [],
        SelectedPractitioners: [],
        SelectedStatus: [],
        SelectedProtocols: [],
        SelectedSettlements: [],
        SelectedDateRange: [undefined, undefined],
        FilterText: undefined,
        showGroupedByVisit: true,
        GroupId: undefined,
    })

    // Row Selection
    const [selectedRows, setSelectedRows] = useState(new Set<TableRowId>());

    // Show consumption grouped by visit
    const [showConsumptionGroupedByVisit, setShowConsumptionGroupedByVisit] = useState<boolean>(true);

    const onSelectionChange: DataGridProps["onSelectionChange"] = (e, data) => {
        setSelectedRows(data.selectedItems);
    };

    const onChangeAgroupation = (GroupByVisit: boolean) => {
        setShowConsumptionGroupedByVisit(GroupByVisit);
        setCurrentPage(1);
        setCurrentFilter(prev => ({
            ...prev,
            showGroupedByVisit: GroupByVisit
        }));
    };

    const onDeleteConsumption = (consumption: ProtocolConsumption) => {
        props.DeleteProtocolConsumption(consumption.protocolId, consumption.id);
    }

    // information panel
    const [isInformationPanelOpen, setIsInformationPanelOpen] = useState(false);
    // create or edit form
    const [isConsumptionFormOpen, setIsConsumptionFormOpen] = useState(false);

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(100);

    // on close form
    const onInformationPanelDismiss = () => {
        setSelectedConsumption(null);
        setIsInformationPanelOpen(false);
    }

    // on close form
    const onConsumptionFormDismiss = () => {
        setSelectedConsumption(null);
        setIsConsumptionFormOpen(false);
    }

    useEffect(() => {
        if (props.protocol && props.StageId && props.PatientNumberInProtocol && props.CurrentVisit === undefined) {
            props.GetProtocolVisitByStageId(props.protocol?.id, props.StageId, props.PatientNumberInProtocol);
        }
    }, [props.StageId, props.PatientNumberInProtocol]);

    useEffect(() => {
        if (props.protocol?.id) {
            props.GetAllPractitioners(1, 1000, undefined);
        }
    }, [props.protocol?.id]);

    useEffect(() => {
        if (props.protocol?.id) {
            props.GetProtocolConsumptionToSettle(props.protocol.id);
            if (props.StageId === undefined) {
                props.GetAllProtocolConsumptionsByProtocol(
                    props.protocol?.id,
                    currentPage,
                    pageSize,
                    currentfilter
                );
            } else {
                props.PatientNumberInProtocol && props.GetAllConsumptionsByVisitId(props.protocol?.id, props.StageId, props.PatientNumberInProtocol);
            }
            props.GetAllProtocolContractAssociations(props.protocol?.id);
        }
        props.onChangeFilters(currentfilter);
    }, [
        props.protocol?.id,
        currentfilter.SelectedProtocolPatients,
        currentfilter.SelectedContractConcepts,
        currentfilter.SelectedCurrencys,
        currentfilter.SelectedContractStages,
        currentfilter.SelectedPractitioners,
        currentfilter.SelectedStatus,
        currentfilter.FilterText,
        currentfilter.SelectedDateRange[0],
        currentfilter.SelectedDateRange[1],
        showConsumptionGroupedByVisit,
        currentPage,
        pageSize
    ]);

    useEffect(() => {
        if (props.CurrentProvider?.id) {
            props.GetProviderById(props.CurrentProvider?.id);
            props.GetAllMedicalProtocols();
        }
    }, [props.CurrentProvider?.id]);

    useEffect(() => {
        if (props.CurrentProvider?.person?.personIdentifier && props.StageId === undefined) {
            props.GetProviderConsumptions(props.CurrentProvider?.id, props.CurrentProvider?.person?.personIdentifier);
        }
    }, [props.CurrentProvider?.person?.personIdentifier]);

    useEffect(() => {
        if (props.StageId === undefined) {
            if (props.protocol?.contractAssociation?.contractId) {
                props.GetContractById(props.protocol?.contractAssociation?.contractId);
            }
        }
    }, [props.protocol?.contractAssociation?.contractId]);




    // on edit payment
    const onEditDebt = (consumption: ProtocolConsumption) => {
        setSelectedConsumption(consumption);
        setIsInformationPanelOpen(true);
    }

    const onRequestUpdate = () => {
        if (props.protocol?.id) {
            setCurrentPage(1);
            props.GetProtocolConsumptionToSettle(props.protocol.id);
            props.GetAllProtocolConsumptionsByProtocol(
                props.protocol?.id,
                1,
                pageSize,
                { ...currentfilter, showGroupedByVisit: showConsumptionGroupedByVisit }
            );
        }
    }

    // Dynamic columns: one per unique contractConceptName (merges entries with different contractConceptId but same name)
    const conceptColumnDefs = useMemo(() => {
        const seen = new Set<string>();
        (props.Consumptions ?? []).forEach((c) => {
            c.conceptValues?.forEach((cv) => {
                seen.add(cv.contractConceptName);
            });
        });
        return Array.from(seen).map((conceptName) =>
            createTableColumn<ProtocolConsumption>({
                columnId: `concept-value-${conceptName}`,
                compare: (a, b) => {
                    const aVal = (a.conceptValues ?? []).filter(cv => cv.contractConceptName === conceptName).reduce((sum, cv) => sum + cv.value, 0);
                    const bVal = (b.conceptValues ?? []).filter(cv => cv.contractConceptName === conceptName).reduce((sum, cv) => sum + cv.value, 0);
                    return aVal - bVal;
                },
                renderHeaderCell: () => <span>{conceptName}</span>,
                renderCell: (item: ProtocolConsumption) => {
                    const matches = (item.conceptValues ?? []).filter(cv => cv.contractConceptName === conceptName);
                    if (matches.length === 0) return <TableCellLayout>—</TableCellLayout>;
                    const total = matches.reduce((sum, cv) => sum + cv.value, 0);
                    const currency = matches[0].currencyCode?.toUpperCase() || 'ARS';
                    return (
                        <TableCellLayout>
                            <strong>
                                {total.toLocaleString('es-AR', { style: 'currency', currency })}
                            </strong>
                        </TableCellLayout>
                    );
                },
            })
        );
    }, [props.Consumptions]);

    const columns: (TableColumnDefinition<ProtocolConsumption> | false)[] = [
        createTableColumn<ProtocolConsumption>({
            columnId: "status",
            compare: (a, b) => {
                return props.ProviderId ? a.costStatus - b.costStatus : a.status - b.status;
            },
            renderHeaderCell: () => {
                return <span>{t('consumptionList.headers.status')}</span>;
            },
            renderCell: (item: ProtocolConsumption) => {
                return (
                    <TableCellLayout>
                        {item.ischangingStatus || item.isDeleting || item.isSaving ?
                            <Spinner size="extra-tiny" />
                            : <div
                                className={'status-mark ' + ComponentFunctions.GetStatusDescription(props.ProviderId ? item.costStatus : item.status).class}
                                title={ComponentFunctions.GetStatusDescription(props.ProviderId ? item.costStatus : item.status).description}
                                aria-label={ComponentFunctions.GetStatusDescription(props.ProviderId ? item.costStatus : item.status).description}
                              ></div>
                        }
                    </TableCellLayout>
                );
            },
        }),
        props.ProviderId !== undefined &&
        createTableColumn<ProtocolConsumption>({
            columnId: "protocol",
            compare: (a, b) => {
                return a.protocolId - b.protocolId;
            },
            renderHeaderCell: () => {
                return <span>{t('consumptionList.headers.protocol')}</span>;
            },
            renderCell: (item: ProtocolConsumption) => {
                return (
                    <TableCellLayout>
                        <Label>{props.GetProtocolById(item.protocolId)?.title}</Label>
                    </TableCellLayout>
                );
            },
        }),
        props.StageId === undefined &&
        createTableColumn<ProtocolConsumption>({
            columnId: "stage",
            compare: (a, b) => {
                return a.stageName?.localeCompare(b.stageName);
            },
            renderHeaderCell: () => {
                return <span>{t('consumptionList.headers.stage')}</span>;
            },
            renderCell: (item: ProtocolConsumption) => {
                return (
                    <TableCellLayout>
                        <Label>{item.stageName}</Label>
                    </TableCellLayout>
                );
            },
        }),
        props.StageId === undefined &&
        createTableColumn<ProtocolConsumption>({
            columnId: "patient",
            compare: (a, b) => {
                return a.patientNumberInProtocol?.localeCompare(b.patientNumberInProtocol);
            },
            renderHeaderCell: () => {
                return <span>{t('consumptionList.headers.patient')}</span>;
            },
            renderCell: (item: ProtocolConsumption) => {
                return (
                    <TableCellLayout>
                        <Label>{item.patientNumberInProtocol}</Label>
                    </TableCellLayout>
                );
            },
        }),
        createTableColumn<ProtocolConsumption>({
            columnId: "concept",
            compare: (a, b) => {
                return a.serviceName.localeCompare(b.serviceName);
            },
            renderHeaderCell: () => {
                return <span>{t('consumptionList.headers.concept')}</span>;
            },
            renderCell: (item: ProtocolConsumption) => {
                return (
                    <TableCellLayout>
                        <div>
                            {item.parentGroupingId &&
                                <span style={{ display: 'inline-block', marginRight: '10px', paddingTop: '5px' }}>
                                    <BranchFork16Filled style={{ fontSize: FontSizes.size28, transform: 'rotate(90deg)', color: 'lightblue' }} />
                                </span>}
                            <Label>
                                <strong>{item.serviceName}</strong>
                            </Label>
                        </div>
                        <p className='item-badges'>
                            {item.condition === 2 && <Badge appearance="tint" size="medium"><span>{t('consumptionList.badges.selectionFailure')}</span></Badge>}
                            {/* {item.typeOfService === 1 && <Badge appearance="outline" size="medium">Planeado</Badge>} */}
                            {item.typeOfService === 2 && <Badge appearance="filled" size="medium" color="danger"> <Important16Regular />&nbsp;<span>{t('consumptionList.badges.additional')}</span></Badge>}
                            {item.typeOfService === 3 && <Badge appearance="outline" size="medium"><span>{t('consumptionList.badges.unexpected')}</span></Badge>}
                            {item.typeOfService === 4 && <Badge appearance="outline" size="medium"><span>{t('consumptionList.badges.notPerformed')}</span></Badge>}
                            {/* {ComponentFunctions.GetTypeOfServiceDescription(item.typeOfService) && <Label><Badge>{ComponentFunctions.GetTypeOfServiceDescription(item.typeOfService)}</Badge></Label>} */}
                            {/* {item.markedAsItemized && <Badge>Itemizable</Badge>} */}
                            {item.tag4?.length > 0 && <Badge appearance="filled" color="important">{item.tag4 === "Procedure" && <AlertOn16Regular />} &nbsp;<span>{t('consumptionList.badges.procedure')}</span></Badge>}
                            {item.tag3?.length > 0 && <Badge appearance="filled" color="warning">{item.tag3 === "Payable" && <CoinStack16Regular />} &nbsp;<span>{t('consumptionList.badges.billable')}</span></Badge>}
                            {item.markedAsRefundable && <Badge><span>{t('consumptionList.badges.refundable')}</span></Badge>}
                        </p>
                    </TableCellLayout>
                );
            },
        }),
        createTableColumn<ProtocolConsumption>({
            columnId: "duedate",
            compare: (a, b) => {
                return new Date(a.serviceDueDate).getTime() - new Date(b.serviceDueDate).getTime();
            },
            renderHeaderCell: () => {
                return <span>{t('consumptionList.headers.dueDate')}</span>;
            },
            renderCell: (item: ProtocolConsumption) => {
                return (
                    <TableCellLayout>
                        {item.serviceDueDate && moment(item.serviceDueDate).format("DD/MM/YYYY hh:mm a")}
                    </TableCellLayout>
                );
            },
        }),
        props.ProtocolId !== undefined &&
        createTableColumn<ProtocolConsumption>({
            columnId: "producer",
            // compare: (a, b) => {
            //     return props.GetPersonByIdentifier(a.producer)?.fullName!.localeCompare(props.GetPersonByIdentifier(b.producer)!.fullName!);
            // },
            renderHeaderCell: () => {
                return <span>{t('consumptionList.headers.producer')}</span>;
            },
            renderCell: (item: ProtocolConsumption) => {
                return item.producer && (
                    <TableCellLayout media={(
                        <Avatar
                            aria-label={item.producer}
                            name={props.GetPersonByIdentifier(item.producer)?.fullName}
                            color="colorful"
                        />
                    )}>
                        {props.GetPersonByIdentifier(item.producer)?.fullName}
                    </TableCellLayout>
                );
            },
        }),
        createTableColumn<ProtocolConsumption>({
            columnId: "totalAmount",
            compare: (a, b) => {
                return (a.totalAmount - b.totalAmount);
            },
            renderHeaderCell: () => {
                return <span>{t('consumptionList.headers.totalAmount')}</span>;
            },
            renderCell: (item: ProtocolConsumption) => {
                return (
                    <TableCellLayout>
                        <strong>{item.totalAmount?.toLocaleString('es-AR', { style: 'currency', currency: item.currencyCode?.toUpperCase() }) || '0.00'}</strong>
                    </TableCellLayout>
                )
            },
        }),
        createTableColumn<ProtocolConsumption>({
            columnId: "withholding",
            compare: (a, b) => {
                return (a.withHolingAmount - b.withHolingAmount);
            },
            renderHeaderCell: () => {
                return <span>{t('consumptionList.headers.withholding')}</span>;
            },
            renderCell: (item: ProtocolConsumption) => {
                return (
                    <TableCellLayout>
                        {!item.withHolingAmount
                            ? <span style={{ color: '#a19f9d' }}>—</span>
                            : <span title={`${item.withHolingPercentage ?? 0}%`}>
                                {item.withHolingAmount.toLocaleString('es-AR', { style: 'currency', currency: item.currencyCode?.toUpperCase() })}
                              </span>
                        }
                    </TableCellLayout>
                );
            },
        }),
        //props.ProviderId === undefined &&
        // createTableColumn<ProtocolConsumption>({
        //     columnId: "pending",
        //     compare: (a, b) => {
        //         return (a.pendingAmount - b.pendingAmount);
        //     },
        //     renderHeaderCell: () => {
        //         return <span>{t('consumptionList.headers.pending')}</span>;
        //     },
        //     renderCell: (item: ProtocolConsumption) => {
        //         return (
        //             <TableCellLayout>
        //                 <strong>{item.pendingAmount?.toLocaleString('es-AR', { style: 'currency', currency: item.currencyCode?.toUpperCase() }) || '0.00'}</strong>
        //             </TableCellLayout>
        //         )
        //     },
        // }),
        ...conceptColumnDefs,
        createTableColumn<ProtocolConsumption>({
            columnId: "actions",
            renderHeaderCell: () => {
                return <span>{t('consumptionList.headers.actions')}</span>;
            },
            renderCell: (item: ProtocolConsumption) => {
                return (
                    <>
                        <Button appearance="subtle" aria-label="Edit" icon={<EditRegular />} onClick={(event) => { event.stopPropagation(); onEditDebt(item) }} />
                        {![1, 2, 3, 6].includes(item.status) && <Button appearance="subtle" aria-label="Delete" icon={<DeleteRegular />} onClick={(event) => { event.stopPropagation(); onDeleteConsumption(item) }} />}
                    </>
                );
            },
        }),
    ];

    const columnSizingOptions = {
        ...Object.fromEntries(
            conceptColumnDefs.map(col => [col.columnId, { defaultWidth: 100, idealWidth: 100 }])
        ),
        status: {
            defaultWidth: 20,
            idealWidth: 20,
        },
        stage: {
            defaultWidth: 130,
            idealWidth: 130,
        },
        patient: {
            defaultWidth: 180,
            idealWidth: 180,
        },
        concept: {
            defaultWidth: 250,
            idealWidth: 250,
        },
        duedate: {
            defaultWidth: 90,
            idealWidth: 90,
        },
        producer: {
            defaultWidth: 150,
            idealWidth: 150,
        },
        Amount: {
            defaultWidth: 70,
            idealWidth: 70,
        },
        totalAmount: {
            defaultWidth: 90,
            idealWidth: 90,
        },
        withholding: {
            defaultWidth: 90,
            idealWidth: 90,
        },
        pending: {
            defaultWidth: 90,
            idealWidth: 90,
        },
        actions: {
            defaultWidth: 50,
            idealWidth: 50,
        },

    };

    const Forms = (
        <>
            {selectedConsumption && <ConsumptionDetailsCompoment
                ProtocolId={selectedConsumption?.protocolId}
                ParentProtocolConsumptionId={undefined}
                ProtocolConsumptionId={selectedConsumption?.id}
                isOpen={isInformationPanelOpen}
                visitId={props.CurrentVisit?.id}
                onClose={onInformationPanelDismiss} />}
            {props.ProtocolId && <ConsumptionFormComponent
                ProtocolId={props.ProtocolId}
                isOpen={isConsumptionFormOpen}
                onClose={onConsumptionFormDismiss}
            />}
        </>
    );

    return (
        <>
            {props.ProtocolId &&
                <div className="ConsumptionListToolbar">
                    <ConsumptionListMenuComponent
                        onRequestUpdate={() => onRequestUpdate()}
                        ProtocolId={props.ProtocolId}
                        showGrouping={props.StageId ? false : true}
                        SelectedConsumptions={
                            props.Consumptions?.filter(
                                (item: ProtocolConsumption) => Array.from(selectedRows).includes(item.id)
                            )
                        }
                        Filters={currentfilter}
                        onChangeAgroupation={onChangeAgroupation}
                    />
                    {props.protocol && props.contract && !props.StageId &&
                        <>
                            <Separator vertical style={{ height: '28px' }} />
                            <ConsumptionListFilterComponent
                                Filters={currentfilter}
                                onChangeFilters={(filters: IConsumptionsFilters) => {
                                    setCurrentPage(1);
                                    setCurrentFilter(filters);
                                }}
                                ProtocolId={props.protocol.id}
                                ContractId={props.contract.id}
                            />
                        </>
                    }
                </div>
            }
            <div className="ConsumptionListContainer">
                {props.protocol && !props.StageId &&
                    <div className="pagination-top">
                        <PaginationControlComponent
                            paginationState={props.protocol.consumptionPagintationState}
                            showedRecords={props.Consumptions?.length ?? 0}
                            isLoading={props.isLoading}
                            setPageNumber={(newPageNumber: number) => setCurrentPage(newPageNumber)}
                            setPageSize={(newPageSize: number) => setPageSize(newPageSize)}
                        />
                    </div>
                }
                <DataGrid
                    className='ConsumptionListGrid'
                    items={
                        showConsumptionGroupedByVisit
                            ? (props.Consumptions?.filter(item => !item.parentGroupingId) ?? [])
                            : (props.Consumptions ?? [])
                    }
                    columns={columns.filter(Boolean) as TableColumnDefinition<ProtocolConsumption>[]}
                    sortable
                    selectionMode="multiselect"
                    selectedItems={selectedRows}
                    onSelectionChange={onSelectionChange}
                    getRowId={(item) => item.id}
                    // containerWidthOffset={-40}
                    resizableColumns={true}
                    columnSizingOptions={columnSizingOptions}

                >
                    <DataGridHeader>
                        <DataGridRow
                            selectionCell={{
                                checkboxIndicator: { "aria-label": "Select all rows" },
                            }}
                        >
                            {({ renderHeaderCell }) => (
                                <DataGridHeaderCell>{renderHeaderCell()}</DataGridHeaderCell>
                            )}
                        </DataGridRow>
                    </DataGridHeader>
                    <DataGridBody<ProtocolConsumption>>
                        {({ item, rowId }) => (
                            <DataGridRow<ProtocolConsumption> className={ComponentFunctions.GetRowClassByStatus(item.status)}
                                key={rowId}
                                selectionCell={{
                                    checkboxIndicator: { "aria-label": "Select row" },
                                }}
                            >
                                {({ renderCell }) => (
                                    <DataGridCell onClick={(e: any) => {
                                        e.stopPropagation();
                                        setSelectedConsumption(item);
                                        setIsInformationPanelOpen(true);
                                    }}>{renderCell(item)}</DataGridCell>
                                )}
                            </DataGridRow>
                        )}
                    </DataGridBody>
                </DataGrid>
                {props.protocol && !props.StageId &&
                    <div className="pagination-bottom">
                        <PaginationControlComponent
                            paginationState={props.protocol.consumptionPagintationState}
                            showedRecords={props.Consumptions?.length ?? 0}
                            isLoading={props.isLoading}
                            setPageNumber={(newPageNumber: number) => setCurrentPage(newPageNumber)}
                            setPageSize={(newPageSize: number) => setPageSize(newPageSize)}
                        />
                    </div>
                }
            </div>
            {Forms}
        </>

    );
};

export default connect(
    ComponentFunctions.mapStateToProps,
    ComponentFunctions.mapDispatchToProps
)(ConsumtionListComponent as any);